import { HTMLAttributes, useEffect, useState } from "react";

interface AutoCounterUpProps extends HTMLAttributes<HTMLSpanElement> {
  start?: number;
  end: number;
  duration?: number;
  delay?: number;
  increaseStep?: number;
}

const AutoCounterUp = ({
  start,
  end,
  duration,
  delay,
  increaseStep = 1,
  ...props
}: AutoCounterUpProps) => {
  const [count, setCount] = useState(start ?? 0);
  const [isCounting, setIsCounting] = useState(true);

  useEffect(() => {
    if (!isCounting) return;

    const timer = setTimeout(() => {
      if (count < end - increaseStep) {
        setCount(count + increaseStep);
      } else {
        setIsCounting(false);
      }
    }, duration ?? 1000);

    return () => clearTimeout(timer);
  }, [count, isCounting, increaseStep, end, duration]);

  return <span {...props}>{count.toFixed(1)}</span>;
};

export default AutoCounterUp;
